export default class Helpers {

    static checkErrors(info) {
        return info.map((el, index) => !el.length && index).filter(el => el !== false);
    }

    static checkUrl(url) {
        return url.match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/)
    }

    static getRandomString() {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
}